import React, { useEffect, useState, Component } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ChevronDown, Phone, Calendar, MessageCircle, MapPin, Mail, Clock, ArrowRight, Facebook, Instagram, Linkedin } from 'lucide-react';
import { Button } from './ui/Button';
import { twMerge } from 'tailwind-merge';
const SERVICES = ['General Medical Consultations', 'Minor Surgical Procedures', 'Safe Medical Circumcision', 'Paternity Testing (DNA)', 'Immunizations', 'Pre-Employment Medical Examinations', 'Family Planning', 'Counseling Services', 'Chronic Disease Management', 'Physiotherapy', 'Optician Services', 'Antenatal Care', 'Postnatal Care', 'Laboratory Services', 'ECG Services', 'Ultrasound Services', 'Dentistry', 'Audiometry', 'Spirometry'];
function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    setMobileMenuOpen(false);
    setServicesOpen(false);
  }, [location.pathname]);
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'About Us',
    path: '/about'
  }, {
    name: 'Patient Information',
    path: '/patient-information'
  }, {
    name: 'Doctors & Staff',
    path: '/doctors'
  }, {
    name: 'Facilities',
    path: '/facilities'
  }, {
    name: 'CSR Initiatives',
    path: '/csr-initiatives'
  }, {
    name: 'Blog',
    path: '/blog'
  }, {
    name: 'FAQ',
    path: '/faq'
  }, {
    name: 'Contact',
    path: '/contact'
  }];
  return <header className={twMerge('fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white', isScrolled ? 'shadow-soft' : '')} data-id="element-271" data-mp="1zk3jsjdo6h3m">
      {/* Top utility bar — desktop only */}
      <div className="hidden md:block bg-brand-gold text-white" data-id="element-272" data-mp="29it1oc5kg1jv">
        <div className="max-w-brand mx-auto px-4 sm:px-6 lg:px-8" data-id="element-273" data-mp="29fx5as9d9kxj">
          <div className="flex items-center justify-between h-10 text-sm" data-id="element-274" data-mp="24jpwmrpl5vbw">
            <div className="flex items-center gap-6" data-id="element-275" data-mp="1gssxygmswuil">
              <span className="flex items-center gap-2" data-id="element-276" data-mp="1gr9dsey0xzbj">
                <Clock className="w-4 h-4 text-white/80" data-id="element-277" data-mp="1bvu1vsjkudhr" />
                Monday – Friday: 8:00 AM – 6:00 PM | Saturday: 9:00 AM - 1:00 PM
              </span>
              <a href="mailto:bookings@maishahealth.co.bw" className="flex items-center gap-2 hover:text-white/80 transition-colors" data-id="element-278" data-mp="1lsyry3gjmt3u">
                <Mail className="w-4 h-4 text-white/80" data-id="element-279" data-mp="y0roylgbbnvg" />
                bookings@maishahealth.co.bw
              </a>
              <span className="flex items-center gap-2" data-id="element-280" data-mp="34rmwcuxp79ld">
                <MapPin className="w-4 h-4 text-white/80" data-id="element-281" data-mp="34q23d9r17ypm" />
                Plot 5245, Tsabong, Botswana
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-282" data-mp="2utgtaa05nxex">
              {[{
              label: 'WhatsApp',
              href: 'https://wa.me/26773241613',
              Icon: MessageCircle
            }, {
              label: 'Facebook',
              href: '#',
              Icon: Facebook
            }, {
              label: 'Instagram',
              href: '#',
              Icon: Instagram
            }, {
              label: 'LinkedIn',
              href: '#',
              Icon: Linkedin
            }].map(({
              label,
              href,
              Icon
            }) => <a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={label} className="w-7 h-7 rounded-full border border-white/50 flex items-center justify-center hover:bg-white hover:text-brand-gold transition-colors" data-id="element-283" data-mp="2744d2q6eup34">
                  <Icon className="w-3.5 h-3.5" data-id="element-284" data-mp="2dilajxvl5pw3" />
                </a>)}
            </div>
          </div>
        </div>
      </div>

      {/* Main navigation row */}
      <div className={twMerge('max-w-brand mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-300', isScrolled ? 'py-2' : 'py-4')} data-id="element-285" data-mp="368twm0t8sufy">
        <div className="flex items-center justify-between" data-id="element-286" data-mp="2wa4c009yovw0">
          {/* Logo */}
          <Link to="/" className="flex items-center group shrink-0" data-id="element-287" data-mp="2s8sllsj9k6mr">
            <img src="https://cdn.magicpatterns.com/uploads/cndFLouYwME2MiiED8zkcC/logo.jpg" alt="Maisha Medical Center — your health is our devotion" className="h-12 md:h-14 w-auto object-contain" data-id="element-288" data-mp="1kw0mp7ebjvxa" />
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-1" data-id="element-289" data-mp="dyfn4h4h75q">
            <Link to="/" className="px-3 py-2 text-sm font-medium text-slate-600 hover:text-brand-red transition-colors" data-id="element-290" data-mp="ehqy2c9oxas">
              Home
            </Link>
            <Link to="/about" className="px-3 py-2 text-sm font-medium text-slate-600 hover:text-brand-red transition-colors" data-id="element-291" data-mp="a647me7djokx">
              About Us
            </Link>

            {/* Services Dropdown */}
            <div className="relative group" data-id="element-292" data-mp="o3kf7t1epoe9">
              <button className="flex items-center gap-1 px-3 py-2 text-sm font-medium text-slate-600 hover:text-brand-red transition-colors" onMouseEnter={() => setServicesOpen(true)} onMouseLeave={() => setServicesOpen(false)} data-id="element-293" data-mp="o4lobryv40tc">
                Services <ChevronDown className="w-4 h-4" data-id="element-294" data-mp="2uwcrj7cmq4a8" />
              </button>

              {servicesOpen && <div className="absolute top-full left-1/2 -translate-x-1/2 w-[600px] bg-white shadow-soft-lg rounded-2xl p-6 grid grid-cols-2 gap-x-8 gap-y-3 border border-slate-100" onMouseEnter={() => setServicesOpen(true)} onMouseLeave={() => setServicesOpen(false)} data-id="element-295" data-mp="21monhcd5cp9">
                  {SERVICES.map(service => <Link key={service} to={`/services/${service.toLowerCase().replace(/\s+/g, '-')}`} className="text-sm text-slate-600 hover:text-brand-red hover:translate-x-1 transition-all flex items-center gap-2" data-id="element-296" data-mp="kwjf7qae6veo">
                      <div className="w-1.5 h-1.5 rounded-full bg-brand-gold/50" data-id="element-297" data-mp="prqfeo4gdhyu" />
                      {service}
                    </Link>)}
                </div>}
            </div>

            <Link to="/patient-information" className="px-3 py-2 text-sm font-medium text-slate-600 hover:text-brand-red transition-colors" data-id="element-298" data-mp="1ibug0ryblrd1">
              Patient Info
            </Link>
            <Link to="/doctors" className="px-3 py-2 text-sm font-medium text-slate-600 hover:text-brand-red transition-colors" data-id="element-299" data-mp="18eg5f8z2vwsn">
              Doctors
            </Link>
            <Link to="/facilities" className="px-3 py-2 text-sm font-medium text-slate-600 hover:text-brand-red transition-colors" data-id="element-300" data-mp="zkkvzoqxbk77">
              Facilities
            </Link>
            <Link to="/csr-initiatives" className="px-3 py-2 text-sm font-medium text-slate-600 hover:text-brand-red transition-colors whitespace-nowrap" data-id="element-301" data-mp="poq5y8kdemue">
              CSR Initiatives
            </Link>
            <Link to="/blog" className="px-3 py-2 text-sm font-medium text-slate-600 hover:text-brand-red transition-colors" data-id="element-302" data-mp="knu4s2releso">
              Blog
            </Link>
            <Link to="/faq" className="px-3 py-2 text-sm font-medium text-slate-600 hover:text-brand-red transition-colors" data-id="element-303" data-mp="w3yse88n0n4o">
              FAQ
            </Link>
            <Link to="/contact" className="px-3 py-2 text-sm font-medium text-slate-600 hover:text-brand-red transition-colors" data-id="element-304" data-mp="m6u525322lma">
              Contact
            </Link>
          </nav>

          {/* CTA & Mobile Toggle */}
          <div className="flex items-center gap-4" data-id="element-305" data-mp="dc5z0cpnozwf">
            <div className="hidden md:block" data-id="element-306" data-mp="8fz1n8bbswq3">
              <Button href="/book" variant="primary" size="sm" icon={<Calendar className="w-4 h-4" data-id="element-308" data-mp="3ulw0i31f1hrb" />} data-id="element-307" data-mp="8ckyvyyr2li4">
                Book Appointment
              </Button>
            </div>
            <button className="lg:hidden p-2 text-brand-navy hover:bg-slate-50 rounded-lg" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-309" data-mp="3qllmc33gzl1d">
              {mobileMenuOpen ? <X className="w-6 h-6" data-id="element-310" data-mp="2a2a29eh0yxj7" /> : <Menu className="w-6 h-6" data-id="element-311" data-mp="2f2wocrqhjiu0" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && <div className="lg:hidden absolute top-full left-0 right-0 bg-white shadow-soft-lg border-t border-slate-100 max-h-[80vh] overflow-y-auto" data-id="element-312" data-mp="1mein8343o6e8">
          <div className="px-4 py-6 flex flex-col gap-4" data-id="element-313" data-mp="1rede46nvkvza">
            {navLinks.map(link => <Link key={link.name} to={link.path} className="text-lg font-medium text-brand-navy py-2 border-b border-slate-50" data-id="element-314" data-mp="1wbwxfkzfjyy3">
                {link.name}
              </Link>)}
            <div className="py-2 border-b border-slate-50" data-id="element-315" data-mp="18muhchkg2e5p">
              <div className="text-lg font-medium text-brand-navy mb-3" data-id="element-316" data-mp="18l9n6t21kx8d">
                Services
              </div>
              <div className="flex flex-col gap-3 pl-4" data-id="element-317" data-mp="iw00pd7j6tw3">
                {SERVICES.slice(0, 8).map(service => <Link key={service} to={`/services/${service.toLowerCase().replace(/\s+/g, '-')}`} className="text-sm text-slate-600" data-id="element-318" data-mp="ss356ppuv4m7">
                    {service}
                  </Link>)}
                <Link to="/services" className="text-sm font-medium text-brand-red flex items-center gap-1 mt-2" data-id="element-319" data-mp="528tibh9vm3j">
                  View All Services <ArrowRight className="w-4 h-4" data-id="element-320" data-mp="9zhboc2f7q4s" />
                </Link>
              </div>
            </div>
            <Button href="/book" variant="primary" fullWidth className="mt-4" data-id="element-321" data-mp="3di29mp7oyvk2">
              Book Appointment
            </Button>
          </div>
        </div>}
    </header>;
}
function Footer() {
  return <footer className="bg-brand-navy text-white pt-20 pb-10" data-id="element-322" data-mp="1zlr8iwnil4wk">
      <div className="max-w-brand mx-auto px-4 sm:px-6 lg:px-8" data-id="element-323" data-mp="1zjwum2anud1z">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-324" data-mp="1vlgxv6os1qbd">
          {/* Brand */}
          <div data-id="element-325" data-mp="1qjrmtr1k1cna">
            <Link to="/" className="inline-flex mb-6" data-id="element-326" data-mp="1qjhz6a3zfhkr">
              <span className="bg-white rounded-2xl p-3 inline-flex" data-id="element-327" data-mp="1ln17j5xkql2x">
                <img src="https://cdn.magicpatterns.com/uploads/cndFLouYwME2MiiED8zkcC/logo.jpg" alt="Maisha Medical Center — your health is our devotion" className="h-16 w-auto object-contain" data-id="element-328" data-mp="1gn56nfk6b9rl" />
              </span>
            </Link>
            <p className="text-slate-300 text-sm leading-relaxed mb-6" data-id="element-329" data-mp="12w0aing0kzm0">
              Providing comprehensive healthcare services, diagnostics,
              physiotherapy, maternal care, and specialist consultations across
              Botswana.
            </p>
            <div className="flex items-center gap-4" data-id="element-330" data-mp="sycd1pr0xe05">
              {[{
              label: 'Facebook',
              href: '#',
              Icon: Facebook
            }, {
              label: 'Instagram',
              href: '#',
              Icon: Instagram
            }, {
              label: 'LinkedIn',
              href: '#',
              Icon: Linkedin
            }].map(({
              label,
              href,
              Icon
            }) => <a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={label} className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-brand-red transition-colors" data-id="element-331" data-mp="16z9jv3xdwjkb">
                  <Icon className="w-5 h-5 text-white" data-id="element-332" data-mp="1kxr60x7n5o04" />
                </a>)}
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-333" data-mp="3afxrmkm6qxf9">
            <h3 className="font-heading font-semibold text-lg mb-6 text-white" data-id="element-334" data-mp="3afo371gsgybo">
              Quick Links
            </h3>
            <ul className="space-y-3" data-id="element-335" data-mp="35gtitv36b1pg">
              {['About Us', 'Patient Information', 'Doctors & Staff', 'Facilities', 'CSR Initiatives', 'Blog', 'Contact'].map(item => <li key={item} data-id="element-336" data-mp="2rhtvqrvb6uve">
                  <Link to={`/${item.toLowerCase().replace(/\s+/g, '-').replace('&-', '')}`} className="text-slate-300 hover:text-brand-gold transition-colors text-sm flex items-center gap-2" data-id="element-337" data-mp="2miid1dbdtfb6">
                    <ChevronDown className="w-3 h-3 -rotate-90 text-brand-gold" data-id="element-338" data-mp="2wf3ghu7r6icw" />
                    {item}
                  </Link>
                </li>)}
              <li data-id="element-339" data-mp="br8pb39ph2rz">
                <Link to="/privacy" className="text-slate-300 hover:text-brand-gold transition-colors text-sm flex items-center gap-2" data-id="element-340" data-mp="bpntzbfkhft2">
                  <ChevronDown className="w-3 h-3 -rotate-90 text-brand-gold" data-id="element-341" data-mp="2meudyu5n82at" />
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-342" data-mp="2qhr0gvyb0ik1">
                <Link to="/terms" className="text-slate-300 hover:text-brand-gold transition-colors text-sm flex items-center gap-2" data-id="element-343" data-mp="2ve957vtmwgwd">
                  <ChevronDown className="w-3 h-3 -rotate-90 text-brand-gold" data-id="element-344" data-mp="35cotzs56ve2p" />
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-345" data-mp="3e5iatu0aalio">
            <h3 className="font-heading font-semibold text-lg mb-6 text-white" data-id="element-346" data-mp="3e3xgo5hvt4lc">
              Contact Us
            </h3>
            <ul className="space-y-4" data-id="element-347" data-mp="3j5mvzxc504f8">
              <li className="flex items-start gap-3 text-sm text-slate-300" data-id="element-348" data-mp="3o36a8x8u4h76">
                <MapPin className="w-5 h-5 text-white shrink-0 mt-0.5" data-id="element-349" data-mp="3o1292n2blwal" />
                <span data-id="element-350" data-mp="23aa9lqwvkdz">Plot 5245, Tsabong, Botswana</span>
              </li>
              <li className="flex flex-col gap-1 text-sm text-slate-300" data-id="element-351" data-mp="3t7qsc947n33v">
                <span className="flex items-center gap-3" data-id="element-352" data-mp="3o8nnaoo8cwvw">
                  <Phone className="w-5 h-5 text-white shrink-0" data-id="element-353" data-mp="3o978ce96g1e5" />
                  <a href="tel:+2676540244" className="hover:text-brand-gold transition-colors" data-id="element-354" data-mp="3k8djninwuik7">
                    +267 6540244
                  </a>
                </span>
                <span className="flex items-center gap-3" data-id="element-355" data-mp="ftvtjbka1wce">
                  <MessageCircle className="w-5 h-5 text-white shrink-0" data-id="element-356" data-mp="b1lwlbkqvw0m" />
                  <a href="https://wa.me/26773241613" target="_blank" rel="noopener noreferrer" className="hover:text-brand-gold transition-colors" data-id="element-357" data-mp="71208a7zwwfj">
                    +267 73241613 (WhatsApp)
                  </a>
                </span>
              </li>
              <li className="flex items-center gap-3 text-sm text-slate-300" data-id="element-358" data-mp="2t0bw9nl3b5cc">
                <Mail className="w-5 h-5 text-white shrink-0" data-id="element-359" data-mp="2xxvfl1wna8b5" />
                <a href="mailto:bookings@maishahealth.co.bw" className="hover:text-brand-gold transition-colors" data-id="element-360" data-mp="2jaa9cz4h3sz0">
                  bookings@maishahealth.co.bw
                </a>
              </li>
              <li className="flex items-start gap-3 text-sm text-slate-300" data-id="element-361" data-mp="2a7rb6sbmu4j3">
                <Clock className="w-5 h-5 text-white shrink-0 mt-0.5" data-id="element-362" data-mp="2f9gl24n4cc5l" />
                <span data-id="element-363" data-mp="20behhug37qoc">
                  Mon - Fri: 8:00 AM - 6:00 PM
                  <br data-id="element-364" data-mp="20d90v4bpnaqb" />
                  Sat: 9:00 AM - 1:00 PM
                  <br data-id="element-365" data-mp="25b0wa8bkdez9" />
                  Sun: Closed
                </span>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div data-id="element-366" data-mp="3imfjckragkf">
            <h3 className="font-heading font-semibold text-lg mb-6 text-white" data-id="element-367" data-mp="3je8efmyy070">
              Newsletter
            </h3>
            <p className="text-slate-300 text-sm mb-4" data-id="element-368" data-mp="1o1otids0y0bc">
              Subscribe to receive health tips and clinic updates.
            </p>
            <form className="flex flex-col gap-3" onSubmit={e => e.preventDefault()} data-id="element-369" data-mp="1izzg4rhbxak3">
              <input type="email" placeholder="Your email address" className="bg-white/10 border border-white/20 rounded-lg px-4 py-2.5 text-sm text-white placeholder:text-slate-400 focus:outline-none focus:border-brand-gold" data-id="element-370" data-mp="1szi037x8owc5" />
              <Button variant="primary" fullWidth data-id="element-371" data-mp="2gpc91eefu0r4">
                Subscribe
              </Button>
            </form>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-372" data-mp="2br11jabm82c2">
          <p className="text-slate-400 text-sm" data-id="element-373" data-mp="mdnrr5kqhm3k">
            © {new Date().getFullYear()} Maisha Medical Center Botswana. All
            rights reserved.
          </p>
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-slate-400" data-id="element-374" data-mp="3rnxct9itkia6">
            <span className="font-semibold text-slate-300" data-id="element-375" data-mp="hchvepn8q7v">Useful Links:</span>
            <a href="https://www.bomra.co.bw/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-376" data-mp="58krobuvydlk">
              BoMRA
            </a>
            <a href="https://www.ilo.org/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-377" data-mp="38rnq5xtuqjek">
              ILO
            </a>
            <a href="https://www.who.int/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-378" data-mp="3nn3m68dzspdl">
              World Health Organization (WHO)
            </a>
          </div>
        </div>
      </div>
    </footer>;
}
function FloatingActions() {
  const whatsappMessage = encodeURIComponent('Hello Maisha Medical Center.\nI would like to book an appointment.\nName:\nPhone:\nPreferred Service:\nPreferred Date:\nPreferred Time:\n\nPlease assist me.');
  return <>
      {/* Desktop Floating */}
      <div className="hidden md:flex fixed bottom-8 right-8 flex-col gap-4 z-50" data-id="element-379" data-mp="28qiyol2a05oq">
        <a href={`https://wa.me/26773241613?text=${whatsappMessage}`} target="_blank" rel="noopener noreferrer" className="w-14 h-14 bg-[#25D366] text-white rounded-full flex items-center justify-center shadow-soft-lg hover:scale-110 transition-transform relative group" data-id="element-380" data-mp="23qxunw891755">
          <div className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20" data-id="element-381" data-mp="1pry8qwc4f6co" />
          <MessageCircle className="w-7 h-7" data-id="element-382" data-mp="3p4sir2zhj89r" />
          <span className="absolute right-full mr-4 bg-white text-slate-800 text-sm font-medium py-1.5 px-3 rounded-lg shadow-soft opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none" data-id="element-383" data-mp="3p3hg56hs06k8">
            Chat on WhatsApp
          </span>
        </a>
      </div>

      {/* Mobile Sticky Bottom Bar */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-slate-100 shadow-[0_-4px_20px_rgba(0,0,0,0.05)] z-50 px-4 py-3 flex items-center justify-between gap-3 pb-safe" data-id="element-384" data-mp="641kpsyer1j0">
        <a href={`https://wa.me/26773241613?text=${whatsappMessage}`} className="flex-1 flex flex-col items-center justify-center gap-1 text-[#25D366]" data-id="element-385" data-mp="3t8hjah9r3iuz">
          <MessageCircle className="w-5 h-5" data-id="element-386" data-mp="3oc0tlimwkwfs" />
          <span className="text-[10px] font-medium" data-id="element-387" data-mp="3jbmly1p7roia">WhatsApp</span>
        </a>
        <Link to="/book" className="flex-[2] bg-brand-red text-white py-2.5 rounded-xl flex items-center justify-center gap-2 font-medium text-sm shadow-md" data-id="element-388" data-mp="3ec07joxng27w">
          <Calendar className="w-4 h-4" data-id="element-389" data-mp="1ckdd1dejtp6o" />
          Book Now
        </Link>
        <a href="tel:+2676540244" className="flex-1 flex flex-col items-center justify-center gap-1 text-brand-navy" data-id="element-390" data-mp="1ci0w93kj1kv7">
          <Phone className="w-5 h-5" data-id="element-391" data-mp="1p1xw9hdcnydy" />
          <span className="text-[10px] font-medium" data-id="element-392" data-mp="1p0wnjjjt3nze">Call Us</span>
        </a>
      </div>
    </>;
}
export function Layout({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="min-h-screen flex flex-col font-sans" data-id="element-393" data-mp="1yr7s98bbe17c">
      <Header data-id="element-394" data-mp="122jnvesiucge" />
      <main className="flex-1 pt-[72px] md:pt-[128px] pb-16 md:pb-0" data-id="element-395" data-mp="1231sozt91yzx">
        {children}
      </main>
      <Footer data-id="element-396" data-mp="1633l0id3hg2j" />
      <FloatingActions data-id="element-397" data-mp="164mzc3f6xh1o" />
    </div>;
}